module.exports = __webpack_public_path__ + "img/many.fc81cc73.svg";